// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___m6bdc","prev":"styles__prev___zEx8M","next":"styles__next___uyS0K"};